@let ctvVideoFlag = (this.ctvVideoFlag$ | async);
<!-- prettier ignore -->
@let audioFlag = (this.audioFlag$ | async);
<tux-page-header
  pageTitle="Create a Campaign"
  [subMenu]="false"
  [breadcrumbs]="breadcrumbs"
>
  <tux-page-header-buttons>
    <p-button
      styleClass="p-button-text p-3"
      (click)="setSelectedCampaignType(undefined)"
      [disabled]="
        !selectedCampaignType ||
        (['video', 'ctv'].includes(selectedCampaignType) && !ctvVideoFlag) ||
        (['audio'].includes(selectedCampaignType) && !audioFlag)
      "
    >
      Cancel
    </p-button>

    <p-button
      [styleClass]="
        ['retargeting', 'linkedin'].includes(selectedCampaignType || '')
          ? 'p-button-primary p-3'
          : 'p-button-outlined p-3'
      "
      (click)="createCampaign(true)"
      [disabled]="
        !selectedCampaignType ||
        ['audio', 'ctv', 'video'].includes(selectedCampaignType || '')
      "
    >
      Use Classic Builder
    </p-button>

    <p-button
      *ngIf="isAdmin$ | async"
      [styleClass]="'p-button-outlined p-3'"
      (click)="selectedCampaignType = 'manually_managed'; createCampaign(false)"
    >
      Create Manual Campaign
    </p-button>

    <p-button
      *ngIf="
        ['display', 'audio', 'ctv', 'video'].includes(
          selectedCampaignType || ''
        )
      "
      [disabled]="
        !selectedCampaignType ||
        (['video', 'ctv'].includes(selectedCampaignType) && !ctvVideoFlag) ||
        (['audio'].includes(selectedCampaignType) && !audioFlag)
      "
      styleClass="p-3"
      type="primary"
      (click)="createCampaign(false)"
    >
      <fa-icon [icon]="sparklesIcon"></fa-icon>
      Use Multi-Campaign Builder
    </p-button>
  </tux-page-header-buttons>
</tux-page-header>

<div class="background-image">
  <h3 class="subheader pb-1">
    First, select the type of campaign you wish to create.
  </h3>
  <br />

  <div class="flex body-container gap-4">
    <div class="flex flex-column gap-5">
      <div class="flex-grid-thirds">
        <p-card
          id="display"
          [style]="{ width: '250px', 'min-height': '160px', cursor: 'pointer' }"
          (focus)="setSelectedCampaignType('display')"
          (blur)="preventBlur($event)"
          tabindex="0"
        >
          <div class="flex justify-content-between align-items-baseline pb-2">
            <tux-svg [src]="displayLogo"></tux-svg>
            <tux-svg [src]="newBuilderLogo"></tux-svg>
          </div>
          <h3 class="pb-3 pt-2">Display Advertising</h3>
          <p>
            Advertise to the right people at your target accounts at every stage
            of the customer journey.
          </p>
        </p-card>
        <p-card
          id="video"
          [style]="{
            width: '250px',
            'min-height': '160px',
            cursor: ctvVideoFlag ? 'pointer' : 'auto',
            'pointer-events': ctvVideoFlag ? 'all' : 'none'
          }"
          (focus)="
            ctvVideoFlag
              ? setSelectedCampaignType('video')
              : cancelEvent($event)
          "
          tabindex="0"
        >
          <div
            class="flex justify-content-between pb-2"
            [ngClass]="{
              'align-items-baseline': ctvVideoFlag,
              'align-items-center': !ctvVideoFlag
            }"
          >
            <tux-svg [src]="videoLogo"></tux-svg>
            <tux-svg *ngIf="ctvVideoFlag" [src]="newBuilderLogo"></tux-svg>
            <p-tag
              *ngIf="!ctvVideoFlag"
              value="Coming Soon"
              class="coming-soon"
            ></p-tag>
          </div>
          <h3
            class="pb-3 pt-2"
            [style]="{ opacity: ctvVideoFlag ? '1' : '0.5' }"
          >
            Video Advertising
          </h3>
          <p [style]="{ opacity: ctvVideoFlag ? '1' : '0.5' }">
            Target the right people online with video ads across the sites they
            already visit.
          </p>
        </p-card>
        <p-card
          id="ctv"
          [style]="{
            width: '250px',
            'min-height': '160px',
            cursor: ctvVideoFlag ? 'pointer' : 'auto',
            'pointer-events': ctvVideoFlag ? 'all' : 'none'
          }"
          (focus)="
            ctvVideoFlag ? setSelectedCampaignType('ctv') : cancelEvent($event)
          "
          tabindex="0"
        >
          <div
            class="flex justify-content-between pb-2"
            [ngClass]="{
              'align-items-baseline': ctvVideoFlag,
              'align-items-center': !ctvVideoFlag
            }"
          >
            <tux-svg [src]="ctvLogo"></tux-svg>
            <tux-svg *ngIf="ctvVideoFlag" [src]="newBuilderLogo"></tux-svg>
            <p-tag
              *ngIf="!ctvVideoFlag"
              value="Coming Soon"
              class="coming-soon"
            ></p-tag>
          </div>
          <h3
            class="pb-3 pt-2"
            [style]="{ opacity: ctvVideoFlag ? '1' : '0.5' }"
          >
            CTV Advertising
          </h3>
          <p [style]="{ opacity: ctvVideoFlag ? '1' : '0.5' }">
            Target high-fit accounts with attention-grabbing video ads on
            streaming platforms like Hulu.
          </p>
        </p-card>
      </div>
      <div class="flex-grid-thirds">
        <p-card
          id="audio"
          [style]="{
            width: '250px',
            'min-height': '160px',
            cursor: audioFlag ? 'pointer' : 'auto',
            'pointer-events': audioFlag ? 'all' : 'none'
          }"
          (focus)="
            audioFlag ? setSelectedCampaignType('audio') : cancelEvent($event)
          "
          (blur)="preventBlur($event)"
          tabindex="0"
        >
          <div
            class="flex justify-content-between pb-2"
            [ngClass]="{
              'align-items-baseline': audioFlag,
              'align-items-center': !audioFlag
            }"
          >
            <tux-svg [src]="audioLogo"></tux-svg>
            <tux-svg *ngIf="audioFlag" [src]="newBuilderLogo"></tux-svg>
            <p-tag
              *ngIf="!audioFlag"
              value="Beta Available"
              class="coming-soon"
            ></p-tag>
          </div>
          <h3 class="pb-3 pt-2" [style]="{ opacity: audioFlag ? '1' : '0.5' }">
            Audio Advertising
          </h3>
          <p [style]="{ opacity: audioFlag ? '1' : '0.5' }">
            Generate interest, drive search volume, and increase brand awareness
            with Audio ads.
          </p>
        </p-card>
        <p-card
          id="retargeting"
          [style]="{ width: '250px', 'min-height': '160px', cursor: 'pointer' }"
          (focus)="setSelectedCampaignType('retargeting')"
          (blur)="preventBlur($event)"
          tabindex="0"
        >
          <div class="flex justify-content-between align-items-baseline pb-2">
            <tux-svg [src]="retargetingLogo"></tux-svg>
          </div>
          <h3 class="pb-3 pt-2">Display Retargeting</h3>
          <p>
            Retarget high-fit site visitors with account-level suppression lists
            and account-based metrics.
          </p>
        </p-card>
        <p-card
          id="linkedin"
          [style]="{ width: '250px', 'min-height': '160px', cursor: 'pointer' }"
          (focus)="setSelectedCampaignType('linkedin')"
          (blur)="preventBlur($event)"
          tabindex="0"
        >
          <div class="flex justify-content-between align-items-baseline pb-2">
            <tux-svg [src]="linkedInLogo"></tux-svg>
          </div>
          <h3 class="pb-3 pt-2">LinkedIn Audiences</h3>
          <p>Sync your Data Studio Accounts for use in LinkedIn campaigns.</p>
          <br />
        </p-card>

        <!-- NATIVE HIDDEN FOR NOW-->
        <!-- <p-card
        [style]="{ width: '250px', 'min-height': '160px', cursor: 'pointer' }"
        (focus)="setSelectedCampaignType('native')"
        (blur)="setSelectedCampaignType(undefined)"
        tabindex="0"
      >
        <div class="flex justify-content-between align-items-baseline pb-2">
          <tux-svg [src]="nativeLogo"></tux-svg>
        </div>
        <h3 class="pb-3 pt-2">Native Advertising</h3>
        <p>
          Promote sponsored content to customers on the sites they already
          visit.
        </p>
      </p-card> -->
        <!-- END OF NATIVE -->
      </div>
      <div class="flex-grid-thirds justify-content-start">
        <tux-svg class="p-2" [src]="createACampaignLogo"></tux-svg>
      </div>
    </div>
    <p-card class="details" [style]="{ height: '75%' }">
      <ng-container *ngIf="!selectedCampaignType">
        <div class="flex gap-3 align-items-center pb-2">
          <tux-svg [src]="gettingStartedLogo"></tux-svg>
          <div class="details-title">Getting Started</div>
        </div>
        <br />
        <p>
          Choose your targeting strategy, select your audience, and engage
          accounts
        </p>
        <br />
        <div class="flex flex-column gap-3">
          <h4>Inventory & Marketplace Advantage</h4>
          <p>
            DemandScience has an open exchange with over 60 supply vendors and
            exclusive access to the private marketplace
          </p>
          <h4>Digital Strategy</h4>
          <p>
            Chat with your DMM to get advice on your digital strategy and
            optimization needs
          </p>
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://resources.terminus.com/c/display-advertising?x=j_sT6x&lx=4gmjDK'
            "
            [isNewWindow]="true"
            >Understanding Targeted Display Advertising for B2B</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'display'">
        <div class="flex justify-content-between">
          <div class="flex gap-3 align-items-center pb-2">
            <tux-svg [src]="displayLogoColor"></tux-svg>
            <div class="details-title">Display Advertising</div>
          </div>
          <tux-svg [src]="newBuilderLogo"></tux-svg>
        </div>
        <br />
        <p>
          Efficiently engage accounts by focusing your spend on the right
          people, titles, and departments. Target high-fit accounts that are
          showing interest, based on intent, website engagement, relationship
          score, and lookalike audiences. Launch your campaigns to influence
          decision-makers at every stage of the revenue flywheel.
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Available Creative Types</h4>
          <tux-svg [src]="displayLogoTypes"></tux-svg>
          <br />
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/29654369232147-How-to-Launch-a-Display-Advertising-Campaign-using-the-Multi-Campaign-Builder'
            "
            [isNewWindow]="true"
            >Using the New Multi-Campaign Builder</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/13549455076499-How-to-launch-a-Display-Advertising-Campaign'
            "
            [isNewWindow]="true"
            >How to Launch a Display Advertising Campaign</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/206622507-Terminus-Display-Advertising-Guidelines-Specifications'
            "
            [isNewWindow]="true"
            >What Ad Sizes and Formats does DemandScience Accept?</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/219050648-HTML5-Creative-Specifications'
            "
            [isNewWindow]="true"
            >All Requirements for HTML5 Creatives</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'ctv'">
        <div class="flex justify-content-between">
          <div class="flex gap-3 align-items-center pb-2">
            <tux-svg [src]="ctvLogoColor"></tux-svg>
            <div class="details-title">Connected TV</div>
          </div>
          <tux-svg [src]="newBuilderLogo"></tux-svg>
        </div>
        <br />
        <p>
          Connected TV (CTV) ads reach over 150 million households and represent
          the fastest-growing channel in video advertising. Utilize targeted
          advertising to engage your audience with visually compelling video
          ads. CTV serves as an effective complement to traditional display
          campaigns, enhancing brand awareness and supporting upselling
          opportunities.
        </p>
        <br />
        <p>
          Upload files ahead of time in the
          <tux-link
            [path]="
              'https://app.demandscienceplatform.com/adex/creative-library'
            "
            [isNewWindow]="true"
            >Asset Library</tux-link
          >
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Available Creative Types</h4>
          <tux-svg [src]="ctvLogoTypes"></tux-svg>
          <br />
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/4406206973587-A-Guide-to-Connected-TV-CTV-Ads-in-Ad-Experiences'
            "
            [isNewWindow]="true"
            >A Guide to Connected TV (CTV) Ads in Ad Experiences</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/29654369232147-How-to-Launch-a-Display-Advertising-Campaign-using-the-Multi-Campaign-Builder'
            "
            [isNewWindow]="true"
            >Using the New Multi-Campaign Builder</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'video'">
        <div class="flex justify-content-between">
          <div class="flex gap-3 align-items-center pb-2">
            <tux-svg [src]="videoLogoColor"></tux-svg>
            <div class="details-title">Video Advertising</div>
          </div>
          <tux-svg [src]="newBuilderLogo"></tux-svg>
        </div>
        <br />
        <p>
          Video ads are highly engaging and have been found to outperform static
          display ad banners by up to 3X. Unlike CTV placements, video ads are
          typically featured on traditional pre-roll ads or web pages.
        </p>
        <br />
        <p>
          Upload files ahead of time in the
          <tux-link
            [path]="
              'https://app.demandscienceplatform.com/adex/creative-library'
            "
            [isNewWindow]="true"
            >Asset Library</tux-link
          >
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Available Creative Types</h4>
          <tux-svg [src]="videoLogoTypes"></tux-svg>
          <br />
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/4423262040467-A-Guide-to-Video-Ads-in-Ad-Experiences'
            "
            [isNewWindow]="true"
            >A Guide to Video Ads in Ad Experiences</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/29654369232147-How-to-Launch-a-Display-Advertising-Campaign-using-the-Multi-Campaign-Builder'
            "
            [isNewWindow]="true"
            >Using the New Multi-Campaign Builder</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'retargeting'">
        <div class="flex gap-3 align-items-center pb-2">
          <tux-svg [src]="retargetingLogoColor"></tux-svg>
          <div class="details-title">Display Retargeting</div>
        </div>
        <br />
        <p>
          Retargeting is a powerful way to bring visitors back to your website.
          Capitalize on your success and keep accounts engaged.
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Available Creative Types</h4>
          <tux-svg [src]="retargetingLogoTypes"></tux-svg>
          <br />
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/360054086914-Display-Retargeting-with-Terminus-Ad-Experiences-Overview'
            "
            [isNewWindow]="true"
            >Display Retargeting with DemandScience Ad Experiences</tux-link
          >
          <tux-link
            [path]="'https://app.demandscienceplatform.com/adex/integrations'"
            [isNewWindow]="true"
            >All Available Audience Source Integrations</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/206622507-Terminus-Display-Advertising-Guidelines-Specifications'
            "
            [isNewWindow]="true"
            >What Ad Sizes and Formats does DemandScience Accept?</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/219050648-HTML5-Creative-Specifications'
            "
            [isNewWindow]="true"
            >All Requirements for HTML5 Creatives</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'audio'">
        <div class="flex gap-3 align-items-center pb-2">
          <tux-svg [src]="audioLogoColor"></tux-svg>
          <div class="details-title">Audio Advertising</div>
        </div>
        <br />
        <p>
          Audio advertising involves delivering ads in audio format through
          online streaming platforms, such as podcasts or music streaming apps.
          Incorporating audio into programmatic media campaigns offers several
          benefits: it allows for easy diversification of creative assets and
          advertising channels, drives search volume by engaging listeners
          through non-skippable content, and boosts brand awareness by
          complementing traditional display campaigns effectively.
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Available Creative Types</h4>
          <tux-svg [src]="audioLogoTypes"></tux-svg>
          <br />
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/4406213411603-A-Guide-to-Audio-Ads-in-Ad-Experiences'
            "
            [isNewWindow]="true"
            >A Guide to Audio Ads in Ad Experiences</tux-link
          >
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/4406213411603-A-Guide-to-Audio-Ads-in-Ad-Experiences#h_01FVFMR36P382Q6KD8XH24ZG3C'
            "
            [isNewWindow]="true"
            >What Ad Sizes and Formats does DemandScience Accept?</tux-link
          >
        </div>
      </ng-container>
      <ng-container *ngIf="selectedCampaignType === 'linkedin'">
        <div class="flex gap-3 align-items-center pb-2">
          <tux-svg [src]="linkedInLogo"></tux-svg>
          <div class="details-title">LinkedIn Audiences</div>
        </div>
        <br />
        <p>
          Synchronize Data Studio account lists with up to 10,000 accounts into
          the LinkedIn company graph. Leverage LinkedIn campaign creation tools
          including lead gen forms, in-content ads, video and sponsored content.
          View campaign-level conversion reporting from LinkedIn directly in
          advertising experiences.
        </p>
        <br />
        <br />
        <div class="flex flex-column gap-3">
          <h4>Resources & More</h4>
          <tux-link
            [path]="
              'https://support.terminus.com/hc/en-us/articles/360001560627-LinkedIn-Ads-Integration-for-Ad-Experiences'
            "
            [isNewWindow]="true"
            >LinkedIn Integrations with Ad Experiences</tux-link
          >
        </div>
      </ng-container>
    </p-card>
  </div>
</div>
